import React from "react";

/** Tiny visual hint of each field type — palette only, not interactive. */
export const PaletteFieldMock = ({ type }) => {
  switch (type) {
    case "textarea":
      return (
        <div className="form-builder-palette-mock is-textarea" aria-hidden="true">
          <span />
          <span />
        </div>
      );
    case "radio":
      return (
        <div className="form-builder-palette-mock is-radio" aria-hidden="true">
          <span />
          <span />
        </div>
      );
    case "checkbox":
      return (
        <div className="form-builder-palette-mock is-checkbox" aria-hidden="true">
          <span />
        </div>
      );
    case "select":
      return (
        <div className="form-builder-palette-mock is-select" aria-hidden="true">
          <span>Select…</span>
        </div>
      );
    case "table":
      return (
        <div className="form-builder-palette-mock is-table" aria-hidden="true">
          <span />
          <span />
        </div>
      );
    case "address":
      return (
        <div className="form-builder-palette-mock is-address" aria-hidden="true">
          <span />
          <span />
        </div>
      );
    case "file":
    case "signature":
      return (
        <div className="form-builder-palette-mock is-upload" aria-hidden="true">
          <span />
        </div>
      );
    case "content":
      return (
        <div className="form-builder-palette-mock is-content" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    case "section":
    case "sub_section":
      return (
        <div className="form-builder-palette-mock is-subsection" aria-hidden="true">
          <span />
        </div>
      );
    default:
      return <div className="form-builder-palette-mock is-input" aria-hidden="true" />;
  }
};

export default PaletteFieldMock;
